import { sbaAxios } from "../utils/sbaAxios";
import { getFinancialStatementUrl, getFinancialInvestmentsDropdown, getFinancialStatementDocument } from "../../config/apiConfig";

import {
    FETCH_FINANCIALSTATEMENT_BEGIN,
    FETCH_FINANCIALSTATEMENT_SUCCESS,
    FETCH_FINANCIALSTATEMENT_FAILURE,

    FETCH_FINANCIALSTATEMENTDROPDOWN_BEGIN,
    FETCH_FINANCIALSTATEMENTDROPDOWN_SUCCESS,
    FETCH_FINANCIALSTATEMENTDROPDOWN_FAILURE,
   
    FETCH_FINANCIALSTATEMENTDOCUMENT_BEGIN,
    FETCH_FINANCIALSTATEMENTDOCUMENT_SUCCESS,
    FETCH_FINANCIALSTATEMENTDOCUMENT_FAILURE,
  
  } from '../constants/financialStatement';


export const getFinancialStatementAction=(assetID,financialYear)=> {
   return (dispatch) => {
       dispatch(fetchFinancialStatementBegin());
       sbaAxios({
           url: `${getFinancialStatementUrl}${assetID},${financialYear}`,
           method: 'get',
       })
      .then((repos) => {
        const financialstatement = {...repos,AssetId:assetID,FinYear:financialYear};
        //Add logic to format the DataItem if needed using map
        dispatch(fetchFinancialStatementSuccess(financialstatement));
        return financialstatement;
      })
      .catch((error) => dispatch(fetchFinancialStatementFailure(error)));
  };
}

export const fetchFinancialStatementBegin = () => ({
  type: FETCH_FINANCIALSTATEMENT_BEGIN,
});

export const fetchFinancialStatementSuccess = (financialStatement) => ({
  type: FETCH_FINANCIALSTATEMENT_SUCCESS,
  payload: {financialStatement},
});


export const fetchFinancialStatementFailure = (errorMessage) => ({
  type: FETCH_FINANCIALSTATEMENT_FAILURE,
  payload: {errorMessage}
});
// GET DROPDOWN
export const GetFinancialInvestmentsDropdownAction = (offset, Next,Searchtext) => {
    return (dispatch) => {
        dispatch(fetchFinancialStatementdropdownBegin());
        sbaAxios({
            url: `${getFinancialInvestmentsDropdown}?offset=${offset}&next=${Next}&searchText=${Searchtext===undefined?"":Searchtext}`,
            method: 'get',
        })
            .then((repos) => {
                const securitydropdown = repos;
                //Add logic to format the DataItem if needed using map
                dispatch(fetchFinancialStatementdropdownSuccess(securitydropdown));
                return securitydropdown;
            })
            .catch((error) => dispatch(fetchFinancialStatementdropdownFailure(error)));
    };
}

export const fetchFinancialStatementdropdownBegin = () => ({
    type: FETCH_FINANCIALSTATEMENTDROPDOWN_BEGIN,
});

export const fetchFinancialStatementdropdownSuccess = (fsSecurityDropdown) => ({

    type: FETCH_FINANCIALSTATEMENTDROPDOWN_SUCCESS,
    payload: {fsSecurityDropdown},
});


export const fetchFinancialStatementdropdownFailure = (errorMessage) => ({
    type: FETCH_FINANCIALSTATEMENTDROPDOWN_FAILURE,
    payload: {errorMessage}
});



export const getFSDocumentAction=(assetID,typeid,id,sourceId)=> {
  return (dispatch) => {
      dispatch(fetchFSDocumentBegin());
      sbaAxios({
          url: `${getFinancialStatementDocument}${assetID},${typeid},${id},${sourceId}`,
          method: 'get',
      })
     .then((repos) => {
       const financialstatementdoc = repos;
       //Add logic to format the DataItem if needed using map
       dispatch(fetchFSDocumentSuccess(financialstatementdoc));
       return financialstatementdoc;
     })
     .catch((error) => dispatch(fetchFSDocumentFailure(error)));
 };
}

export const fetchFSDocumentBegin = () => ({
 type: FETCH_FINANCIALSTATEMENTDOCUMENT_BEGIN,
});

export const fetchFSDocumentSuccess = (fsDocuments) => ({
 type: FETCH_FINANCIALSTATEMENTDOCUMENT_SUCCESS,
 payload: {fsDocuments},
});


export const fetchFSDocumentFailure = (errorMessage) => ({
 type: FETCH_FINANCIALSTATEMENTDOCUMENT_FAILURE,
 payload: {errorMessage}
});
